import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";

interface IModalConfirmWindowProps {
  setShowModal: any;
  handleDeleteUser: any;
  target?: string;
  message?: string | null;
}

const ModalConfirmWindow: React.FC<IModalConfirmWindowProps> = ({
  setShowModal,
  handleDeleteUser,
  target = "user",
  message = null,
}) => {
  const { t } = useTranslation();
  useEffect(() => {
    document.body.classList.add("overflow-hidden");

    return () => {
      document.body.classList.remove("overflow-hidden");
    };
  }, []);
  return (
    <div className="modal-overlay">
      <div className="modal-panel p-6 w-full max-w-lg">
        <h2 className="text-lg font-semibold text-slate-900 mb-6">
          {message
            ? message
            : target === "user"
              ? t("adminPanel.confirmMsgUser")
              : t("adminPanel.confirmMsgTeam")}
        </h2>
        <div className="flex justify-end gap-4">
          <button
            onClick={() =>
              setShowModal((prev: any) => ({
                ...prev,
                isCreateTeam: false,
                visible: false,
                userIndex: null,
              }))
            }
            className="px-6 py-2 text-sm font-medium bg-slate-200 text-slate-900 rounded-lg hover:bg-slate-300"
          >
            {t("adminPanel.cancel")}
          </button>
          <button
            onClick={handleDeleteUser}
            className="px-6 py-2 text-sm font-medium bg-red-500 text-white rounded-lg hover:bg-red-600"
          >
            {t("adminPanel.delete")}
          </button>
        </div>
      </div>
    </div>
  );
};

export { ModalConfirmWindow };
